import { render, staticRenderFns } from "./CompanyClientCard.vue?vue&type=template&id=ec7ae91a&"
import script from "./CompanyClientCard.vue?vue&type=script&lang=js&"
export * from "./CompanyClientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports